var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeepPressure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_95_48130)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 45.9784L12.0033 45.4784H12H-0.0216222C-3.04725 45.4784 -5.5 43.0256 -5.5 40C-5.5 36.9624 -3.03757 34.5 0 34.5H12H16.2645C19.6913 34.5 22.8991 36.1844 24.8446 39.0054C28.2996 44.0151 35.7004 44.0151 39.1554 39.0054C41.1009 36.1844 44.3087 34.5 47.7355 34.5H52H64C67.0376 34.5 69.5 36.9624 69.5 40C69.5 43.0256 67.0472 45.4784 64.0216 45.4784L52 45.4784L51.996 45.4784L52 45.9784L51.9959 45.4784L51.9957 45.4784L51.9949 45.4784L51.9916 45.4784L51.9785 45.4785L51.9268 45.4789L51.7269 45.4804C51.5527 45.4816 51.2996 45.4833 50.9835 45.4852C50.3514 45.489 49.4679 45.4936 48.4625 45.4966C46.451 45.5027 43.9542 45.5027 42.0062 45.4784C39.6422 45.449 37.9026 45.4583 36.0354 45.4684C34.8151 45.475 33.5403 45.4819 32.0011 45.4784C30.8224 45.4757 29.7858 45.4712 28.8133 45.467C26.2416 45.4558 24.1175 45.4466 20.9949 45.4784C19.2412 45.4963 16.9939 45.4963 15.1835 45.4918C14.2786 45.4896 13.4835 45.4862 12.9146 45.4834C12.6301 45.482 12.4022 45.4808 12.2455 45.4799L12.0656 45.4788L12.019 45.4785L12.0072 45.4784L12.0042 45.4784L12.0035 45.4784L12.0033 45.4784L12 45.9784Z",
    stroke: "#404D6A"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.23212,
    y1: 38.0928,
    x2: 2.23212,
    y2: 43.0928,
    stroke: "#B1B6C2",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.2321,
    y1: 38.0928,
    x2: 9.23212,
    y2: 43.0928,
    stroke: "#B1B6C2",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.2321,
    y1: 38.0928,
    x2: 16.2321,
    y2: 43.0928,
    stroke: "#B1B6C2",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 46.2321,
    y1: 38.0928,
    x2: 44.2321,
    y2: 43.0928,
    stroke: "#B1B6C2",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53.2321,
    y1: 38.0928,
    x2: 51.2321,
    y2: 43.0928,
    stroke: "#B1B6C2",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.2321,
    y1: 38.0928,
    x2: 58.2321,
    y2: 43.0928,
    stroke: "#B1B6C2",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 29V29C22.5221 29 24.8577 30.3286 26.1466 32.4965L26.5544 33.1825C28.9763 37.2562 34.8273 37.3878 37.43 33.427L38.3285 32.0596C39.5834 30.1499 41.715 29 44 29V29",
    stroke: "#404D6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 26V26C28.0565 26 29.0406 26.5367 29.6127 27.4249L29.7578 27.6502C30.7914 29.2551 33.1189 29.3092 34.226 27.754L34.5899 27.2427C35.145 26.463 36.0429 26 37 26V26",
    stroke: "#404D6A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_95_48130"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeepPressure);
export default __webpack_public_path__ + "static/media/deep-pressure.87892fc59ead70b21ea0caf291c25219.svg";
export { ForwardRef as ReactComponent };